<template>
    <div class="cursor_title">
        <span class="txt">{{cursortitle}}</span>
    </div>
</template>
<script>
export default {
    props:{
        cursortitle:{
            type:String,
            default:'公开课'
        }
    }
}
</script>
<style lang="scss" scoped>
.cursor_title{
    font-size: 22px;
    font-weight: bold;
    color: #182837;
    line-height: 1;
    .txt{
        display: block;
        padding-left: 15px;
        position: relative;
        &::after{
            content: " ";
            width: 5px;
            height: 100%;
            background: #3964E6;
            position: absolute;
            left: 0;
            bottom: 0;
        }
    }
}
</style>